// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"258":"locale-fr","377":"locale-ru","766":"locale-ge","866":"locale-es","931":"locale-de","972":"locale-tr"}[chunkId] || chunkId) + "." + {"258":"f44cde7d","377":"eae80bd6","388":"bc4ce697","478":"59fd1fb0","488":"fe352d30","766":"0123266f","866":"6ec1f5d4","931":"cc89b258","972":"1e3af80b"}[chunkId] + ".chunk.js";
};